module.exports = __webpack_public_path__ + "img/3-3.3fe82767.svg";